import Vue from 'vue'
import { DEFAULT_DATE, FORMAT_DATE } from '@/utils/config'

export default (date) => {
  if (Vue.moment(date, DEFAULT_DATE, true).isValid()) {
    return Vue.moment(date, DEFAULT_DATE).format(FORMAT_DATE)
  }

  return Vue.moment(date, DEFAULT_DATE).format(FORMAT_DATE)
}
